import React from 'react';
import { Container, Divider } from './styles';
import { useTranslation } from 'react-i18next';
import CounterInput from '../../../commons/CounterInput';

const RoomsSection = ({ updateReduxState = () => {}, formValues, optionsByRealEstateType = [] }) => {
  const { t } = useTranslation();

  const getMaxByType = type => {
    if (type === 'parking') return 999;
    return 50;
  };

  return (
    <Container>
      {optionsByRealEstateType.map(op => {
        return (
          <div key={op.featureId}>
            <CounterInput
              min={0}
              max={getMaxByType(op.name)}
              label={`${t(op.label)}${op.isOptional ? '' : '*'}`}
              onCounterChange={v => updateReduxState(v, op.featureId)}
              counterValue={formValues[op.featureId]}
              disabledDecrease={formValues[op.featureId] <= op.initialValue || formValues[op.featureId] === ''}
              disabledIncrease={formValues[op.featureId] >= getMaxByType(op.name)}
              dataPubli={`professionalPubli-featureId_${op.featureId}`}
            />
            <Divider />
          </div>
        );
      })}
    </Container>
  );
};

export default RoomsSection;
